import { Location } from '../../enum/Location';
import { SelectOption } from '../../../../services/select/interfaces/SelectOption';

export const locationOptions: SelectOption[] = [
  { title: 'US', value: Location.US },
  { title: 'Non-US', value: Location.NonUS },
  { title: 'Global', value: Location.Global },
];
